<template>
  <v-list
    style="border-radius: 0px !important"
    dense
    :class="listClass"
    v-scroll="{ handler: onScroll }"
  >
    <!-- v-scroll.self="onScroll" -->
    <template v-for="item in header">
      <v-list-item
        :key="item.id"
        v-if="typeof data[item.field] !== 'undefined'"
        :class="listItemClass"
        style="min-height: 24px"
      >
        <v-list-item-content class="py-1"
          >{{ item.caption }}
        </v-list-item-content>
        <v-list-item-content
          style="
            font-size: 0.85rem;
            color: rgba(200, 255, 255, 0.8);
            margin-top: 2px;
            line-height: 1.4;
            font-weight: 400;
          "
          class="align-end py-1 text-justify"
        >
          {{ data[item.field] !== null ? data[item.field] : item.default }}
        </v-list-item-content>
      </v-list-item>
    </template>

    <slot name="default"></slot>
  </v-list>
</template>

<script>
export default {
  name: "TreeItem",
  data: () => ({}),
  computed: {},
  props: {
    header: {
      type: [Object, Array],
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: undefined,
    },
    listClass: {
      type: String,
      default: "transparent pb-2 px-2 overflow-y-auto",
    },
    listItemClass: {
      type: String,
      default: "px-2",
    },
  },
  methods: {
    onScroll(e) {
      console.log(e);
    },
  },
};
</script>
